var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "z-report-block",
      class: { "z-report-block--landscape-mode": _vm.landscapeMode },
      attrs: { href: _vm.link, target: "_blank" },
    },
    [
      _c("div", {
        staticClass: "z-report-block__image",
        style: "background-image: url(" + _vm.image + ")",
      }),
      _vm._v(" "),
      _c("div", { staticClass: "z-report-block__title" }, [
        _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "z-report-block__wrapper" },
          [
            _c("span", {
              staticClass: "z-report-block__title-period",
              domProps: { innerHTML: _vm._s(_vm.titlePeriod) },
            }),
            _vm._v(" "),
            _c(
              "tag",
              { attrs: { rounded: "", theme: "gray-dark", size: "l" } },
              [_vm._v("PDF")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }